<template>
  <div>
    <div class="mt-goods-top flex-row-align">
      <div class="mt-goods-img">
        <img :src="imgServer+'logo.png'" alt="" />
      </div>
      <div class="mt-goods-single" style="margin-top: 15px;">
        <div class="mt-goods-name">{ {{detailInfo.deliveryType == 1 ? '自提订单' : '配送订单'}}} -- {{orderStatusTxt}}</div>
        <div class="mt-goods-id">订单号：{{detailInfo.orderNo}}</div>
      </div>
      <el-button v-if="detailInfo.orderStatus == 0" style="display: none;" class="mt-order-btn" type="primary">订单改价</el-button>
      <el-button style="display: none;" v-if="detailInfo.orderStatus == 1 && detailInfo.deliveryType == 0" class="mt-order-btn" type="primary" @click="sendOpenBtn">发货</el-button>
      <div class="mt-goods-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="订单信息" name="orderInfo">
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 用户信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  用户ID：{{detailInfo.userId}}
                </div>
                <div class="mt-order-row">
                  用户昵称：{{detailInfo.userNickName}}
                </div>
                <div class="mt-order-row">
                  绑定手机：{{detailInfo.userPhone}}
                </div>
                <div class="mt-order-row">
                  推荐人：{{detailInfo.parentNickName}}
                </div>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 收货信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  收货地址：{{detailInfo.addressDetail}}
                </div>
                <div class="mt-order-row">
                  联系人：{{detailInfo.realName}}
                </div>
                <div class="mt-order-row">
                  联系手机：{{detailInfo.phone}}
                </div>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 商品信息
              </div>
              <div class="mt-order-table">
                <el-table
                    :data="detailInfo.wechatGoodsOrderGoodsPageVoList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="thumb"
                      label="商品图片"
                      width="180">
                      <template slot-scope="scope">
                        <el-image
                          style="width: 40px;"
                          :src="scope.row.thumb"
                          :preview-src-list="[scope.row.thumb]"
                          fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="goodsName"
                      label="商品名称"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="specName"
                      label="商品规格">
                    </el-table-column>
                    <el-table-column
                      prop="goodsNumber"
                      label="商品数量">
                    </el-table-column>
                  </el-table>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 订单信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  创建时间：{{detailInfo.createTime}}
                </div>
                <div class="mt-order-row">
                  商品总数：{{detailInfo.buyNumber}}
                </div>
                <div class="mt-order-row">
                  商品总价：{{detailInfo.orderMoney}}
                </div>
                <div class="mt-order-row">
                  支付金额：{{detailInfo.realPayMoney}}
                </div>
                <div class="mt-order-row">
                  折扣金额：{{detailInfo.discountMoney}}
                </div>
                <div class="mt-order-row">
                  支付邮费：{{detailInfo.moveMoney}}
                </div>
                <div class="mt-order-row">
                  支付方式：{{detailInfo.payTypeText}}
                </div>
                <div class="mt-order-row">
                  原始单号：-@.LP{{detailInfo.id}}
                </div>
                <div class="mt-order-row">
                  订单ID：{{detailInfo.id}}
                </div>
                <div class="mt-order-row">
                  核销信息：{{detailInfo.writeOffRemark}}
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 订单改价弹窗 -->
    <el-dialog
      title="订单改价"
      :visible.sync="changePriceShow"
      width="960px">
      <el-form :model="changePriceForm" label-width="140px">
        <el-form-item label="订单价格：">
          {{detailInfo.orderMoney}}
        </el-form-item>
        <el-form-item label="待支付价格：">
          {{detailInfo.realPayMoney}}
        </el-form-item>
        <el-form-item label="更改价格：" prop="price">
          <el-input style="width: 420px;" v-model="changePriceForm.price" placeholder="请输入新支付价格"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { fetchOrderDetailById } from '@/api/order'
export default {
  name: 'OrderDetail',
  props: {
    infoId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'orderInfo',
      detailInfo: {
        deliveryType:'',
        thumb: '',
        orderStatus: '',
        orderNo: '',
        userId: '',
        parentNickName: '',
        userPhone: '',
        userNickName: '',
        realName: '',
        phone: '',
        addressDetail: '',
        wechatGoodsOrderGoodsPageVoList: [],
        createTime: '',
        buyNumber: '',
        orderMoney: '',
        realPayMoney: '',
        discountMoney: '',
        moveMoney: '',
        payTypeText: '',
        writeOffRemark: ''
      },
      orderStatusTxt:'',
      // 订单改价弹窗
      changePriceShow:false,
      changePriceForm:{
        price:''
      }
    }
  },
  watch: {
    "infoId":{
      handler(newVal, oldVal){
        this.detailInfoFun();
      }
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {},
    detailInfoFun(){
      var that = this;
      fetchOrderDetailById({id:that.infoId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          var orderStatusTxt = '';
          switch (data.orderStatus) {
            case 0:
              orderStatusTxt = '待支付';
              break;
            case 1:
              orderStatusTxt = '待发货';
              break;
            case 2:
              if(data.deliveryType == 0){
                orderStatusTxt = '待收货';
              }else{
                orderStatusTxt = '待使用';
              }
              break;
            case 3:
              if(data.deliveryType == 0){
                orderStatusTxt = '已完成';
              }else{
                orderStatusTxt = '已核销';
              }
              break;
          }
          that.orderStatusTxt = orderStatusTxt;
          that.detailInfo = data;
        }
      });
    },
    // 订单改价操作
    saveBtn(){
      var changePriceForm = this.changePriceForm;
    },
    // 订单发货-打开弹窗
    sendOpenBtn(){
      this.$emit('sendOrderInfo', 1, this.infoId);
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/Detail.vue